export default function anchorLink(anchor) {
  if (anchor === undefined || anchor === '') {
    return ''
  }
  if (anchor.startsWith('#')) {
    return anchor
  }
  return `#${anchor}`
}
